
export enum NullableTipoLocomocaoEnum {
  Moto = 'Moto',
  Carro = 'Carro',
  TransporteColetivo = 'TransporteColetivo',
  APe = 'APe',
}
